import React, { Fragment, memo } from "react";

const ErrorSpan = ({ touched, errors, fieldName }) => {
    return (
        <Fragment>
            {touched[fieldName] && <p className="mt-1 text-sm text-red-400">{errors[fieldName]}</p>}
        </Fragment>
    )
}

export default memo(ErrorSpan);